/** Entry, plan lookup, and home must share a palette before data is available. */
export const isLearningEntryPath = (path: string) =>
  /^\/textbook-learning(?:\/(?:home|setup))?\/?$/.test(path);

export const learningStartupBackground =
  'linear-gradient(180deg, transparent, #f6f7f9 430px), radial-gradient(ellipse at 95% 0, #fff2b9, transparent 60%), #ffdf87';
